import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'
import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import { hasScreenIn } from './hasScreenInCompNode'
import { ScreenInCssFeature } from './screenIn.types'
import { screenInDomApplier } from './screenInDomApplier'

export const screenInCssFeature: ScreenInCssFeature = {
	featureName: 'screenIn',
	experimentName: 'OPEN_TO_ALL',
	renderableNodes: { hasScreenIn },
	intermediateNodes: {},
	dataMaps: ['behaviors_data'],
	domApplier: screenInDomApplier,
}

export const page: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(screenInCssFeature)
}
export const editor: BindFeature = page
